import instance from '@/service/instance';
import { AxiosPromise } from 'axios';
import { LoginDto } from '@/dto/auth/LoginDto';

const resource: string = '/auth';

export default {
  login(loginDto: LoginDto): AxiosPromise<any> {
    return instance.post(`${resource}/signin`, loginDto);
  },
  logout(id: number | string) {
    return instance.post(`${resource}/logout/${id}`);
  }
};
